import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';
import { Logo } from '../components/ui/Logo.jsx';

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const redirectTo = location.state?.from?.pathname || '/';

  async function onSubmit(e) {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      await login(email, password);
      navigate(redirectTo, { replace: true });
    } catch (ex) {
      setErr(ex.body?.error === 'invalid_credentials' ? 'Email sau parolă greșită.' : 'Eroare la autentificare.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-4">
      <div className="mb-8 flex flex-col items-center">
        <Logo size={64} />
        <p className="mt-3 text-sm text-muted">Management flotă auto</p>
      </div>

      <form onSubmit={onSubmit} className="card space-y-4">
        <h2 className="text-2xl font-semibold tracking-tight">Autentificare</h2>

        {err && (
          <div className="rounded-lg border border-danger/30 bg-danger/10 px-3 py-2 text-sm text-danger">
            {err}
          </div>
        )}

        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted">Email</span>
          <input
            type="email"
            required
            autoFocus
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 text-base focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
          />
        </label>

        <label className="block">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted">Parolă</span>
          <input
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded-lg border border-border bg-paper px-3 py-2.5 text-base focus:border-teal focus:outline-none focus:ring-2 focus:ring-teal/20"
          />
        </label>

        <button type="submit" disabled={busy} className="btn-primary w-full">
          {busy ? 'Se verifică…' : 'Intră'}
        </button>

        <p className="text-center text-xs text-muted">
          Ai primit o invitație? <Link to="/invite" className="text-teal-bright underline">Activează contul</Link>
        </p>
      </form>
    </div>
  );
}
